import { makeStyles } from '@material-ui/styles'

export const actionsClasses = makeStyles((theme) => ({
  actionsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 'fit-content',
    gap: theme.spacing(1),
  },
  actionDefaultStyle: {
    flex: 'none',
    width: 'fit-content',
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.shape.borderRadius,
    '& p, & .MuiButton-label': {
      lineHeight: 1.08,
      fontSize: theme.typography.pxToRem(14),
    },
  },
  actionButtonStyle: {
    justifyContent: 'flex-end',
    '& .MuiButton-label': {
      display: 'flex',
      flexDirection: 'row-reverse',
    },
  },
  adherenceDate: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.campaign.adherenceDateColor,
    backgroundColor: theme.palette.campaign.adherenceDateBackgroundColor,
    '& p': {
      color: theme.palette.campaign.adherenceDateColor,
    },
  },
}))
